import script from "./migration-center.vue?vue&type=script&setup=true&lang=js"
export * from "./migration-center.vue?vue&type=script&setup=true&lang=js"

import "./migration-center.vue?vue&type=style&index=0&id=369bad98&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-369bad98"]])

export default __exports__